/**
 * 开场页自动弹当日额度（fe-spec §3.8.1/§3.2 · PRD-A S1.1）。
 *
 * - 额度 = per owner × 用户本地自然日至多 1 次；存储值 = 本地自然日 yyyy-MM-dd，跨日自然失效
 * - 「已进过」口径：自动弹 push 与用户主动进入 `/brief/report` 均落定当日额度
 *   （PRD：同一自然日内已被自动弹过、或已主动进过一次汇报，之后只能从摘要条进入）
 * - fail-safe：写入失败返回 false，调用方不弹（fe-spec §2.4 宁可少弹不可双弹）
 * - key 形态先例 `trackerReportAutoshowStorage`（per-owner 前缀），日期值形态先例
 *   `briefNewIndicatorClearStorage`（自然日 yyyy-MM-dd）
 */
const REPORT_OPENING_ENTERED_DATE_PREFIX = "report_opening_entered_date::";

export function reportOpeningEnteredDateKey(ownerId: string): string {
  return `${REPORT_OPENING_ENTERED_DATE_PREFIX}${ownerId}`;
}

function toLocalIsoDate(d = new Date()): string {
  const month = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
}

/** 当日已弹过 / 已主动进过（额度已用） */
export function hasReportOpeningEntryToday(
  ownerId: string | null | undefined,
  date = toLocalIsoDate(),
): boolean {
  if (typeof window === "undefined" || !ownerId) {
    return false;
  }
  try {
    return localStorage.getItem(reportOpeningEnteredDateKey(ownerId)) === date;
  } catch {
    return false;
  }
}

/**
 * 落定当日额度（幂等写）。
 * @returns 写入是否成功；失败时调用方按 fail-safe 不弹
 */
export function markReportOpeningEntered(
  ownerId: string,
  date = toLocalIsoDate(),
): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    localStorage.setItem(reportOpeningEnteredDateKey(ownerId), date);
    return true;
  } catch {
    return false;
  }
}
